<a
  class="btn btn-action btn-small"
  [routerLink]="{ cxRoute: 'dispenserAgreementShipmentHistory', params: { agreementCode: this.agreementId } } | cxUrl"
  [queryParams]="sharedService.getQueryParamsLocal('dispenserAgreementShipmentHistory')"
  >
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.dispenserShipments' | cxTranslate }}
</a>

@if (shipment) {
  <div class="container">
    <div class="card agreement-detail">
      <div class="row card-body agreement-detail-content">
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserShipment.id' | cxTranslate }}</b>
          <span>{{ shipment.code }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserShipment.type' | cxTranslate }}</b>
          <span>{{ 'dispenserShipment.shipTo.' + shipment.type | cxTranslate }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserShipment.date' | cxTranslate }}</b>
          <span>{{ shipment.shipmentDate | cxDate: 'longDate' }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'shared.status' | cxTranslate }}</b>
          <span>{{ 'dispenserShipment.status.' + shipment.status | cxTranslate }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserShipment.address' | cxTranslate }}</b>
          <span>{{ shipment.address?.formattedAddress }}</span>
        </div>
      </div>
    </div>
  </div>
}

@if (!showInitialLoader) {
  <div>
    @if (entries) {
      <div class="row align-items-end">
        <div class="col-12 col-md form-group">
          <button class="btn btn-primary btn-small" (click)="downloadCSV()" [disabled]="disableWhenNoDataOrDownloading">
            <i [class]="downloadingCsv ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
            {{ 'dispenserShipment.downloadEntries' | cxTranslate }}
          </button>
        </div>
        <div class="col col-sm-6 col-md form-group">
          <app-custom-search-input
            title="Search Material"
            placeholder="Search by Material Number #"
            (eventSearch)="onSearch($event)"
          ></app-custom-search-input>
        </div>
        <div class="col col-sm-6 col-md-auto form-group">
          <app-custom-select
            [title]="'shared.filterBy' | cxTranslate"
            (changeValue)="filterChange($event)"
            [options]="filterOptions"
            [clearable]="true"
            placeHolder="Status"
          ></app-custom-select>
        </div>
      </div>
    }
  </div>
}

@if (entries?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="code"
    [rows]="entries.results"
    [pagination]="entries.pagination"
    (changePagination)="pageChange($event)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (showMessageWhenNoData) {
    <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
  }
}


@if (showLoaderOnStartupOrWhenNoData) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
